import React from 'react';

import { useDispatch } from 'react-redux';
import { FormSpy } from 'react-final-form';

import { formsActions } from '@store/forms';

function FormStateToRedux({ form }) {
  const dispatch = useDispatch();

  return (
    <FormSpy
      onChange={(state) => {
        /**
         * Needed to avoid race condition when it dispatches changes
         * while parent is still rendering
         * https://github.com/final-form/react-final-form/issues/809
         */
        if (Object.keys(state.modified).length > 0) {
          dispatch(formsActions.setForm({ name: form, state }));
        }
      }}
    />
  );
}

export default FormStateToRedux;
